// import { WordopolisWordDirection } from "../../gql/graphql";
import { WordopolisCellCords } from "../../reducers/wordopolis";
import { directionTransformers } from "../directionTransformers";

export type getBoardPath = (
  start: WordopolisCellCords,
  end: WordopolisCellCords,
  directions: string[],
  board: string[][],
) => WordopolisCellCords[] | null;

export const getBoardPath: getBoardPath = (start, end, directions, board) => {
  let pathToWord: WordopolisCellCords[] | null = null;

  for (const direction of directions) {
    if (pathToWord) {
      break;
    }
    const directionFunction = directionTransformers[direction];
    let x = start.x;
    let y = start.y;
    const path = [start];

    while (x >= 0 && y >= 0 && y < board.length && x < board[0].length && board[y][x] !== null) {
      if (x === end.x && y === end.y) {
        pathToWord = path;
        break;
      }

      const newCords = directionFunction(x, y);
      x = newCords.x;
      y = newCords.y;
      path.push({ x, y });
    }
  }

  return pathToWord;
};
